import { gql, useQuery } from '@apollo/client';

export const GET_PAYROLL_ACCOUNTING_ACTIVE_SETTINGS = gql`
  query getActivePayrollAccountingSetting($companyId: ObjectId!) {
    getActivePayrollAccountingSetting(companyId: $companyId) {
      _id
      active
      companyId
      type
      softwareTarget
      createdBy
    }
  }
`;

export const useGetPayrollAccountingActiveSetting = (companyId?: string) => {
  const { data, loading } = useQuery(GET_PAYROLL_ACCOUNTING_ACTIVE_SETTINGS, {
    variables: {
      companyId,
    },
    skip: !companyId,
    fetchPolicy: 'no-cache',
  });

  return { setting: data?.getActivePayrollAccountingSetting || {}, loading };
};
